//the classes that represent our app state
class MeetingRoom {
  constructor(props = {}) {
    this.id = props.id || '';
    this.name = props.name || '';
    this.parentGroupName = props.parentGroupName || '';
    this.participants = props.participants || [];
    this.invitationDetails = props.invitationDetails || {};
    this.headerName = '';
    this.fetching = false; //saving,updating,deleting loading flag so buttong display circle indicator when call is at server.
  }
}
class MeetingRoomForm {
  constructor(props = {}) {
    this.id = props.id || '';
    this.name = props.name || '';
    this.videoCallQualityId = 0;
    this.organisationNetworkId = 0;
    this.postCallUrl = '';
    this.callProviderUrl = '';
    this.callerGuestUrl = '';
    this.postCallOption = 0;
  }
}

class Group {
  constructor(props = {}) {
    this.meetingRoomForm = props.meetingRoomForm || new MeetingRoom();
    this.name = props.name || '';
    this.id = props.id || '';
    this.parentOrg = props.parentOrg || '';
    this.postCallUrl = props.postCallUrl || '';
    this.providerUrl = props.providerUrl || '';
    this.callerGuestUrl = props.callerGuestUrl || '';
    this.videoCallQualityId = props.videoCallQualityId || 0;
    this.videoCallQuality = props.videoCallQuality || undefined; //object  of the videoCallQuality option
    this.postCallOptionId = props.postCallOptionId || 0;
    this.purgeCallerDetails = true;
    this.email = props.email || '';
    this.headerName = '';
  }
}

class WaitingArea {
  constructor(props = {}) {
    this.id = props.id || '';
    this.name = props.name || '';
    this.isSuspended = props.isSuspended || false;
    this.peopleWaiting = props.peopleWaiting || 0;
    this.peopleBeingAttended = props.peopleBeingAttended || 0;
    this.longestWait = props.longestWait || 0;
    this.idleCalls = props.idleCalls || 0;
    this.operatingHours = props.operatingHours || { isOpen: true };
    this.rooms = props.rooms || [];
    this.providerCallConfig = props.providerCallConfig || {};
    this.myProviderStatus = props.providerCallConfig || {};
    this.headerName = props.headerName || {};
    this.permissions = props.permissions || [];
    this.daysOfWeekSelected = props.daysOfWeekSelected || [false, false, false, false, false, false, false];
    this.times = props.times || [
      {
        to: '',
        from: '',
      },
    ]; //starts with one empty object
    this.timezone = props.timezone || '';
    this.timeWindowSelection = APP.LANGUAGE.CreateWaitingArea.ConsumerTimeOptions[0];
    this.myProviderStatus = {};
    this.callSummary = {
      peopleWaiting: 0,
      peopleBeingAttended: 0,
      peopleIdle: 0,
      longestWait: 0,
    };
    // this.pubNubChannel = 'RANDOM-WA-123', telling one-wa page does not subscribe
    this.callEntryPageUrl = props.callEntryPageUrl || '';
    this.tags = props.tags || [];
    this.reportingTagsEnabled = props.tags || false;
  }
}

class Organisation {
  constructor(props = {}) {
    this.id = props.id || '';
    this.networkId = props.networkId || '';
    this.name = props.name || '';
    this.abbreviatedName = props.abbreviatedName || '';
    this.meetingRoomCount = props.meetingRoomCount || 0;
    this.waitingAreaCount = props.waitingAreaCount || 0;
    this.pubNubChannel = props.pubNubChannel || '';
    this.tags = props.tags || [];
    this.reportingTagsEnabled = props.tags || false;
    this.permissions = props.permissions || [];

    this.headerName = props.headerName || {};
    this.groups = props.groups || '';
    this.groupForm = props.groupForm || new Group();
    this.waitingAreas = props.waitingAreas || [];
    this.waitingAreaRoomSelected = props.waitingAreaRoomSelected || new MeetingRoom();
    this.waitingAreasGray = props.waitingAreasGray || [];
    this.waitingArea = props.waitingArea || new WaitingArea();
    this.waitingAreaRoomsGray = props.waitingAreaRoomsGray || [];
    this.description = props.description || '';
    this.country = props.country || '';
    this.email = props.email || '';
    this.telephone = props.telephone || '';
    this.supportEmail = props.supportEmail || '';
    this.supportTelephone = props.supportTelephone || '';
    this.supportName = props.supportName || '';
    this.allowLowBandwidthConnections = props.allowLowBandwidthConnections || true;
    this.allowWaitingAreasToRecord = props.allowWaitingAreasToRecord || false;
    this.purgeCallerDetailsEndOfCall = props.purgeCallerDetailsEndOfCall || true;
    this.termsAndConditionUrl = props.termsAndConditionUrl || '';
    this.troubleshootingUrl = props.troubleshootingUrl || '';
    this.privacyPolicyUrl = props.privacyPolicyUrl || '';
    this.orgLogoBase64 = props.orgLogoBase64 = '';
    this.additionalWaitingAreaInfo = props.additionalWaitingAreaInfo || '';
    this.additionalMeetingRoomInfo = props.additionalMeetingRoomInfo || '';
    this.moreAssistanceInfo = props.moreAssistanceInfo || '';
    this.city = props.city || '';
    this.postalCode = props.postalCode || '';
    this.latitude = props.latitude || '';
    this.longitude = props.longitude || '';
    this.address = props.address || '';
    this.state = props.state || '';
    this.fakeAddress = props.fakeAddress || '';
  }
}

class User {
  constructor(props = {}) {
    this.firstName = props.firstName || '';
    this.lastName = props.lastName || '';
    this.membershipAndRoles = props.membershipAndRoles || [];
    this.userImageUrl = props.userImageUrl || '';
    this.email = '';
    this.isAdmin = false;
    this.timezone = '';
    this.displayNameInHeader = '';
    this.hasMeetingRooms = true;
    this.hasWaitingAreas = true;
    this.featuresEnabled = {};
    this.waitingAreas = [];
    this.meetingRooms = [];
    this.organisations = [];
    this.userCallsDetails = [];
  }
}

class GlobalMessage {
  constructor(props = {}) {
    this.visible = props.visible || false;
    this.text = props.text || '';
    this.messageType = props.messageType || APP.LANGUAGE.GlobalMessageTypes.Bad;
    this.autoHide = false;
  }
}

class videoCallQualityProfile {
  constructor(props = {}) {
    this.id = props.id || 0;
    this.name = props.name || '';
    this.mediaCaptureParam = props.mediaCaptureParam || '';
    this.constrainBandwidth = props.constrainBandwidth || '';
    this.description = props.description || '';
    this.sortOrder = props.sortOrder || 0;
  }
}

export const waitingAreaInitialState = {
  cleanWaitingAreaSmsNotificationForm: {
    mobilePhoneNumber: '',
    updating: false,
    secondsIntervalToSmsSendNotification: 0,
  },
  notifyRoomParticipantsForm: {
    message: '',
  },
  waitingAreaSmsNotificationForm: {
    mobilePhoneNumber: '',
    updating: false,
    secondsIntervalToSmsSendNotification: 0,
  },
  showUpdateSmsNotification: false,
  showCreateSmsNotification: false,
  // list of all waiting areas
  waitingAreas: [],
  // selected waiting area being shown in View-One view
  selectedWaitingAreaId: null,

  //represent if waiting areas were loaded once or not
  waitingAreasInitiallyLoaded: false,

  // hold state for waiting area create/edit form until form has not been saved
  waitingAreaForm: new WaitingArea(),

  //CreateWA
  createWAForm: {
    waitingAreaName: '',
    shortUrlDomain: '',
    networkTypeId: 0, // Standard Consultation or Group Consultation
    isGroupConsultationFeatureEnabled: false, // Is Group Consultation feature enabled by default
  },

  // return a empty copy of waiting Area for resetting the form
  cleanWaitingArea: new WaitingArea(),

  cleanOrganisationalUnit: new Organisation(),
  //Self provision Validate token
  selfProvisionCreateForm: {
    isLinkValid: false,
    email: '',
    personId: 0,
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    organisationName: '',
    organisationAbbreviation: '',
    waitingAreaName: '',
    waitingAreaUrl: '',
    agreeTermsAndCondition: false,
    shortUrlDomain: '',
    token: '',
    timezone: '',
  },

  // State for waiting area before calls form
  beforeCallsForm: {
    isFirstNameMandatory: true,
    isLastNameMandatory: false,
    isDobMandatory: false,
    isPhoneNumberMandatory: false,
  },
  beforeCallsImportantInfoForm: {
    importantInfo: '',
  },
  // State for waiting area after calls form
  afterCallsForm: {
    postCallOption: 0,
    postCallUrl: '',
    callProviderUrl: '',
    callerGuestUrl: '',
  },

  // Support Contact
  supportContactForm: {
    supportName: '',
    supportEmail: '',
    supportPhone: '',
    supportWebsite: '',
    moreAssistance: '',
  },
  // Information for Callers
  informationForCallersForm: {
    moreAssistance: '',
    fileName: '',
    uploadFileNotAccepted: false,
  },
  // Advanced menu
  showAdvancedMenu: false,

  // state of create waiting area popup
  // TODO - Should this be saved in internal state of respective components?
  currentCreateWaitingAreaStep: 1,

  // tracks the progress of create waiting area steps filled in by user
  // TODO - Should this saved in internal state of respective components?
  currentFilledCreateWaitingAreaStep: [false, false, false, false],

  // Is "Create Waiting area" popup being displayed
  showCenterPanelCreate: false,

  // Is app in process of fetching waiting rooms data from API server
  fetchingWaitingAreas: {},

  // text value of waiting area search filter text box
  // TODO - Should this be saved in internal state of respective components?
  currentWaitingAreaFilter: '',
  currentWaitingAreasFilter: '',
  consultNowInitiatedWaitingAreasFilter: '',
  consultNowInporgressWaitingAreasFilter: '',
  currentWaitingAreasFilterByNetworkId: null,
  currentWaitingAreaMemberFilter: '',
  currentWaitingAreaTagFilter: '',
  // When a tag is selected, its info including all available tag values are stored
  selectedTagObject: {
    tagId: null,
    tagName: '',
    canAssignTagValue: false,
    canMultiSelect: false,
    description: null,
    availableTagValues: [],
  },
  // It has tag info and values has been saved for a particular tag
  assignTagValuesForm: {
    tagId: null,
    tagName: '',
    canMultiSelect: false,
    canAssignTagValue: false,
    description: null,
    tagValuesHasBeenSaved: [], // values has been saved in server
    tagValuesEdited: [], // dirty values being modified but not saved in server yet
  },
  // Waiting Area Website button details
  // TODO - Should this be a property of WaitingArea class?
  waitingAreaWebsiteButton: {},
  // Caller Entry Point
  callerEntryPointForm: {
    isWaitingAreaPublic: true,
    shortUrl: '',
    customUrl: '',
    longUrl: '',
    // The final URL that will be submitted
    urlExtenstionIsInUse: false,
  },

  // During Calls
  isRecordingAvailableOnPortal: null,
  callQualityOptions: null,
  duringCallsForm: {
    callQuality: '0',
    displayMessageMinutes: 0,
    displayMessageSeconds: 15,
    message: '',
    moreAssistance: '',
    isRecordingEnabled: false,
    isOrganisationRecordingEnabled: false,
  },

  // Consult Now
  consultNowVidyoRoomId: null,
  consultNowAuthTicket: null,
  //Logo Pause and Image Form
  waitingAreaLogoPauseImageForm: {
    logoFileName: '',
    logoBase64: '',
    cameraDisabledFileName: '',
    cameraDisabledBase64: '',
    orgLogoUrl: '',
    defaultSystemLogoUrl: '',
    logoUrl: '',
    cameraUrl: '',
    defaultCameraUrl: '',
    isSaving: false,
  },

  // Add Users form
  addUsersForm: {
    message: '',
    selectedRoles: [],
  },

  // Participants' workflow
  selectedParticipantForm: {},
  selectedVideoCallRoomForm: {},
  selectedVideoCallRoomId: null,
};

export const organisationInitialState = {
  // list of all organisations
  organisations: [],
  organisationalUnitLogoImageForm: { orgLogoUrl: '', isChanged: false },
  // selected Organisation being shown in View-One view
  // TODO - change it with selectedOrganisationId
  selectedOrganisation: null,

  // hold state for Organisation create/edit form until form has not been saved
  orgUnitForm: new Organisation(),

  // return a empty copy of Organisation for resetting the form
  cleanOrgUnitForm: new Organisation(),

  // used as ref data on group page
  // TODO - find use cases
  groupOrganisations: [],

  // state of create organisation popup
  // TODO - Should this be saved in internal state of respective components?
  currentCreateOrgStep: 1,

  // tracks the progress of create organisation steps filled in by user
  // TODO - Should this be saved in internal state of respective components?
  currentFilledCreateOrgSteps: [false, false, false, false],

  // Is "Create Organisation" popup being displayed
  showCenterPanelCreate: false,

  // Is app in process of fetching Organisations (+ Permissions) data from API server
  fetchingOrganisationsWithPermission: false,

  // Is app in process of fetching Organisations data from API server
  fetchingOrganisations: false,

  organisationsInitiallyLoaded: false,

  // Is app in process of deleting Organisation data from API server
  deletingOrg: false,

  // text value of organisation search filter text box
  // TODO - Should this be saved in internal state of respective components?
  currentOrgUnitFilter: '',

  // TODO - what is in this groups property? If not being used, then remove it
  groups: {},
  updatedSharedWASettingsForOrgForm: {},
  selectedTagObject: {
    tagId: null,
    tagName: '',
    canAssignTagValue: false,
    canMultiSelect: false,
    description: null,
    availableTagValues: [],
  },
  assignTagValuesForm: {
    tagId: null,
    tagName: '',
    canMultiSelect: false,
    canAssignTagValue: false,
    description: null,
    tagValuesHasBeenSaved: [],
    tagValuesEdited: [],
  },
  // Add Users form
  addUsersForm: {
    message: '',
    selectedRoles: [],
  },
  // Entity admin
  entitySearchForm: {
    searchString: '',
    currentActivePageNo: 0,
    searchedEntityType: 'org',
  },
  entityStats: {
    matchedOUs: 0,
    wasOfMatchedOUs: 0,
    mrsOfMatchedOUs: 0,
    totalOURows: 0,
    totalWAs: 0,
    totalMRs: 0,
  },
  meetingRoomsDeletionStatus: APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED,
  waitingAreasDeletionStatus: APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED,
  organizationDeletionStatus: APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED,
};

export const usersInitialState = {
  // is user logged in
  loggedIn: false,
  userHasWaitingAreas: false,
  userHasMeetingRooms: false,
  userHasOrganisations: false,
  // profile for logged in user
  userProfile: new User(),
  waitingAreaParticipants: {},
  // is fetching profile from API server
  // TODO - do we need at global state level
  fetching: false,
  fetchingLogin: false,
  fetchingUserProfileAfterLogin: false,
  fetchingUserProfile: false,

  fetchingMeetingRooms: false,
  userCurrentMeetingRoomCall: {},
  // Email to for password reset action
  userEmailForPasswordReset: '',

  // Timezones supported by app
  timezones: [],

  // Is user profile image editable
  isProfileImageEditable: false,

  // Is app in process of saving user profile on API server
  savingUserProfile: null,

  // Image user in Avatar editor
  profileImageDropped: null,
  changePassword: {},
  resetPassword: {},
  isInCall: false,
  isInGCCall: false,
  usersIcanManage: [],
  usersIcanManageForAdmin: [],

  // state for search and select users controls
  searchSelectUsersForm: {
    searchResults: [],
    isLoading: false,
    searchTerm: '',
    selectedUsers: [],
  },

  // features enabled for this user in system
  featuresEnabled: {},
  allUsersSearchForm: {
    searchString: '',
    currentActivePageNo: 0,
  },
  currentAllUsersSearchFilter: '',
  hasRolesInOtherNetworks: false,
  myRoles: [],
  // Pagination
  entitySearchForm: {
    searchString: '',
    currentActivePageNo: 0,
  },
  isOnEntityListingPage: false,
  isGroupConsultationFeatureEnabled: false,
  userCallsDetails: [],
};

export const portalSettingInitialState = {
  // set if portal settings
  videoQualityProfile: {
    videoCallQualityProfileFetching: true,
    defaultVideoCallQuality: 0,
    videoCallQualityProfiles: [],
  },
  portalSettingLoader: false,
};

export const sharedInitialState = {
  asOfNow: new Date(),
  redirectToPageNotFound: false,
  hideHelpAboutThisPage: false,
  redirectToPageFeatureUnavailable: false,
  pubnubConnectionStatus: {
    isClientHealthy: true,
    isServerHealthy: true,
    lastHeartbeatUtc: null,
    secondsToAutoRefresh: null,
    secondsSincePubnubDown: null,
  },
  updateSearchColumn: null,
  previousPage: '',
};

export const navigationInitialState = {
  currentPageTitle: '',
};

export const globalMessagesInitialState = {
  // Message object
  messageData: new GlobalMessage(),
};

export const modalInitialState = {
  modalVisible: false,
  hideWhenClickAwayQuickView: false,
  showQuickViewModal: false,
  showViewWaitingAreaParticipantModal: false,
  showAddToCallWaitingAreaModal: false,
  showCallHistoryModal: false,
  showNotifyRoomParticipantModal: false,
  showSuspendWAModal: false,
  showBeforeCallsModal: false,
  showBeforeCallsImportantInfoModal: false,
  showCallerEntryModal: false,
  showDuringCallsModal: false,
  showManageRolesForUsersModal: false,
  showManageRolesForOrgUsersModal: false,
  showSupportContactModal: false,
  showSharedWAForOrgUnitModal: false,
  showRemoveTagConfirmationModal: false,
  showEditTagValueModal: false,
  showAssignTagsModal: false,
  showOrgUnitGeneralInfoModal: false,
  showOrgUnitSupportContactModal: false,
  showOrganisationalUnitLogoImageModal: false,
  showCreateOUModal: false,
  showMeetingRoomResetGuestLink: false,
  showEditMeetingRoomModal: false,
  showMeetingRoomAddUsersModal: false,
  showMeetingRoomManageUsersRolesModal: false,
  showDeleteMeetingRoomModal: false,
  showMyRolesModal: false,
  showOtherUsersProfileModal: false,
  showOtherUsersRolesModal: false,
  showManageInvitationsModal: false,
  showShareByEmailModal: false,
  showShareByTextModal: false,
  showConsultNowSettingModal: false,
  showConsultNowInvitationModal: false,
  showCancelCNInvitationModal: false,
  showExtendCNInvitationModal: false,
  showOURecordingSettingModal: false,
  showWAAudioSettingModal: false,
  showGCSettingsModal: false,
  showOuDefaultGcSettingsModal: false,
  showOuWaGcSettingsModal: false,
  showDeleteOrganizationModal: false,
};

export const reportInitialState = {
  fetchingReports: false,
  hideDataOutdateWarning: true,
  reports: {
    total: 0,
    active: 0,
    new: 0,
  },
  showSetMinDurationsModal: false,
  typingMinConDurationValue: 0,
  typingMinMeetingDurationValue: 0,
  minConsultationDurValue: 0,
  minMeetingDurValue: 0,
  startDate: null,
  endDate: null,
  updatingMinDurations: false,
};

// TODO - refactor out indiviual exports for each entity and finally remore this default export (VCM-1190)
export default {
  // TODO - refactor out groups reducer while working on
  groups: [],

  currentGroupFilter: '',
  cleanGroupForm: new Group(),
  groupForm: new Group(),

  // TODO - refactor out meetingroom reducer while working on
  currentMeetingRoomNameFilter: '',
  currentMeetingRoomFilterByNetworkId: null,
  meetingRoomGroups: [],
  fetchingOrganisationsWereIcanCreateWaitingAreas: false,
  organisationsWereIcanCreateWaitingAreas: [],

  cleanMeetingRoomForm: new MeetingRoomForm(),
  selectedMeetingRoom: new MeetingRoomForm(),
  meetingRoomForm: new MeetingRoom(),
  meetingRooms: [],
  meetingRoomsInQV: [],
  showCreateWaitingAreaModal: false,
  hideWhenClickAwayQuickView: false,

  meetingRoomRecentCalls: [],
  fetchingRecentCalls: false,
  totalMeetingRooms: 0,
  selectedParticipantForm: {
    selectedParticipant: {},
    isUserInThisCall: false,
  },
  // Add Users form
  addUsersForm: {
    message: '',
    selectedRoles: [],
  },
  mrSearchForm: {
    searchString: '',
    currentActivePageNo: 0,
  },
  isOnMRListingPage: false,
};
